import { render, staticRenderFns } from "./list.vue?vue&type=template&id=0084efc4&scoped=true&"
import script from "./list.js?vue&type=script&lang=js&"
export * from "./list.js?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=0084efc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0084efc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0084efc4')) {
      api.createRecord('0084efc4', component.options)
    } else {
      api.reload('0084efc4', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=0084efc4&scoped=true&", function () {
      api.rerender('0084efc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/list/list.vue"
export default component.exports